import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreativeContext, Property_ID } from '@sites/data-hmm/hmm-incubator';

export const contextSearchActions = createActionGroup({
  source: 'DashboardFeatureCreative ContextSearchComponent',
  events: {
    init: emptyProps(),
    search: props<{ term: string }>(),
    goToPage: props<{ page: number }>(),
  },
});

export const pickerActions = createActionGroup({
  source: 'DashboardFeatureCreative CreativePickerComponent',
  events: {
    init: props<{ initialCreativeIds?: string[] }>(),
    loadNextPage: emptyProps(),
  },
});

export const contextEffectActions = createActionGroup({
  source: 'DashboardFeatureCreative ContextEffects',
  events: {
    listContext: props<{ term?: string; creativeIds?: string[] }>(),
    listContextSuccess: props<{ contexts: CreativeContext[] }>(),
    listContextFailure: props<{ error: Error }>(),
    searchContext: props<{ term?: string; creativeIds?: string[] }>(),
    searchContextSuccess: props<{
      contexts: CreativeContext[];
      nextPageToken?: string;
      totalCount: number;
      availableProperties?: Property_ID[];
      availableMediaTypes?: string[];
      availableFormats?: string[];
    }>(),
    searchContextFailure: props<{ error: Error }>(),
    setCurrentPage: props<{ page: number }>(),
    fetchPage: props<{
      page: number;
      pageToken: string;
      searchTerm?: string;
      creativeIds?: string[];
    }>(),
    fetchPageSuccess: props<{
      page: number;
      contexts: CreativeContext[];
      nextPageToken?: string;
      totalCount: number;
      availableProperties?: Property_ID[];
      availableMediaTypes?: string[];
      availableFormats?: string[];
    }>(),
    fetchPageFailure: props<{ error: Error }>(),
  },
});
